exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".custom-file-input~.custom-file-label::after {\n    content: \"Selecteer file\";\n}\n\n.loader {\n    border: 8px solid #f3f3f3;\n    /* Light grey */\n    border-top: 8px solid #3498db;\n    /* Blue */\n    border-radius: 50%;\n    width: 40px;\n    height: 40px;\n    animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/course-form/course-form.component.css
// module id = 394
// module chunks = 0